import {NgModule} from "@angular/core";
import {MonacoEditorComponent} from "./monaco-editor-wrapper.component";

@NgModule({
    declarations: [
        MonacoEditorComponent,
    ],
    imports: [],
    providers: [],
    exports: [MonacoEditorComponent]
})
export class MonacoEditorModule {

}
